import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { VideoContentModel } from '@libs/cms/models';
import { ContentBaseComponent } from '../content-base.component';
import { DEFAULT_VIDEO_ASPECT_RATIO } from './video-content.constants';
import { VideoContentPlayerComponent } from './video-content-player';

@Component({
  selector: 'ui-video-content',
  templateUrl: './video-content.component.html',
  styleUrls: ['./video-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    VideoContentPlayerComponent,
  ],
})
export class VideoContentComponent extends ContentBaseComponent<VideoContentModel> {
  public readonly aspectRatio: Signal<string> = computed((): string => {
    const view: VideoContentModel = this.data();

    if (!view.width || !view.height) {
      return DEFAULT_VIDEO_ASPECT_RATIO;
    }

    return `${view.width} / ${view.height}`;
  });

  public readonly maxWidth: Signal<number | undefined> = computed((): number | undefined => (
    this.data().width || undefined
  ));
}
